import { Button, Elevation, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import Text from '../../../components/Text';
import AllotmentCreateOverlay from '../components/AllotmentCreateOverlay';
import AllotmentList from '../components/AllotmentList';

const AllotmentListPage = () => {
  const history = useHistory();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const onCreated = (modelId: string) => {
    AppToaster.success('Kontingent hinzugefügt!');
    history.push(`/allotments/${modelId}`);
  };

  return (
    <ContentCard elevation={Elevation.TWO} className="mb-5">
      <AllotmentCreateOverlay
        isOpen={isCreateDialogOpen}
        onSuccess={onCreated}
        onClose={() => setIsCreateDialogOpen(false)}
      />
      <ContentCardHeader
        leftElement={
          <Text large className="mr-2">
            Kontingente
          </Text>
        }
        rightElement={
          <>
            <Button
              text="Hinzufügen"
              icon={IconNames.ADD}
              intent={Intent.PRIMARY}
              className="ml-2"
              onClick={() => setIsCreateDialogOpen(true)}
            />
          </>
        }
      />
      <AllotmentList />
    </ContentCard>
  );
};

export default AllotmentListPage;
